import React from "react";
import { Inbox } from "lucide-react";
import { IMAGES } from "../../config/images";

export default function AdminEmptyState({ icon: Icon = Inbox, title, description, action, showMascot = false }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-4 text-center rounded-lg border border-slate-200 bg-white">
      {showMascot ? (
        <img
          src={IMAGES.mascot}
          alt=""
          className="h-14 w-14 object-contain mb-4 opacity-90"
          draggable={false}
        />
      ) : (
        <div className="w-10 h-10 rounded-md bg-slate-100 flex items-center justify-center mb-3">
          <Icon className="h-5 w-5 text-slate-400" />
        </div>
      )}
      <p className="text-slate-800 font-medium text-sm">{title}</p>
      {description && <p className="text-slate-500 text-sm mt-1 max-w-sm leading-relaxed">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
